<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="29.28" height="22.959" viewBox="0 0 29.28 22.959">
    <g transform="translate(-408.36 -389.021)">
      <g>
        <path
          d="M422.485,411.98a26.172,26.172,0,0,1-3.881-.288c-2.444-.391-2.6-2.42-2.847-5.491a30.159,30.159,0,0,1,0-6.322,45,45,0,0,1,1.137-6.178l.1-.375h1.186V392.32a3.48,3.48,0,0,1,1.677-2.8,3.737,3.737,0,0,1,2.987-.349c.527.083,1.2.189,2.135.28a3.024,3.024,0,0,1,2.26,1.183,4.165,4.165,0,0,1,.648,2.7h1.179l.131.3s.477,1.1,1.1,2.422c.837,1.771.078,9.82.046,10.162-.25,2.605-.741,4.985-3.969,5.482A26.263,26.263,0,0,1,422.485,411.98Zm-4.716-17.655a44.215,44.215,0,0,0-1.017,5.663,29.121,29.121,0,0,0,0,6.121c.274,3.461.539,4.36,2,4.6a25.316,25.316,0,0,0,7.466,0c2.315-.357,2.851-1.765,3.122-4.59.376-3.925.519-8.636.046-9.639-.435-.919-.8-1.731-.983-2.15h-1.7l.123-.6a3.646,3.646,0,0,0-.4-2.505,2.054,2.054,0,0,0-1.551-.777c-.956-.093-1.65-.2-2.191-.286-1.217-.192-1.505-.235-2.332.225a2.464,2.464,0,0,0-1.179,1.968v1.975Z"
          fill="#777"
        />
        <path
          d="M417.224,399.667a.91.91,0,0,1-.508-.149c-.675-.44-.539-1.617-.482-1.966l.987.161a1.956,1.956,0,0,0,.045.964,2.7,2.7,0,0,0,.343-.183,2.959,2.959,0,0,0,.984-1.558c.343-.9.768-2.024,2.274-2.122.628-.041,1.15-.121,1.611-.192a4.432,4.432,0,0,1,2.986.243,4.884,4.884,0,0,1,1.468,1.045,5.349,5.349,0,0,0,1.045.834,1.587,1.587,0,0,0,1.8.01l.563.828a2.58,2.58,0,0,1-2.914,0,6.28,6.28,0,0,1-1.2-.959,3.894,3.894,0,0,0-1.209-.862,3.522,3.522,0,0,0-2.392-.15c-.481.074-1.025.157-1.7.2-.826.054-1.049.544-1.4,1.479a3.806,3.806,0,0,1-1.371,2.04A1.754,1.754,0,0,1,417.224,399.667Z"
          fill="#777"
        />
        <path
          d="M422.49,409.151c-4.848,0-6.6-1.228-6.692-1.3l.592-.805-.3.4.292-.4c.031.02,3.164,2.136,12.88.46l.17.986A41.158,41.158,0,0,1,422.49,409.151Z"
          fill="#777"
        />
        <rect
          width="0.999"
          height="2.825"
          transform="translate(417.858 393.906) rotate(-19.948)"
          fill="#777"
        />
        <path
          d="M427.271,396.134l-.913-.408a7.191,7.191,0,0,0,.571-2.051l.992.122A8.139,8.139,0,0,1,427.271,396.134Z"
          fill="#777"
        />
        <path
          d="M412,406.677a9.7,9.7,0,0,1,0-9.172.478.478,0,0,1,.841.454,8.671,8.671,0,0,0,0,8.264.477.477,0,1,1-.829.474Zm-1.365,1.656a.478.478,0,0,0,.176-.653h0a11.2,11.2,0,0,1,0-11.184.478.478,0,1,0-.828-.478,12.164,12.164,0,0,0,0,12.141.479.479,0,0,0,.653.175h0ZM434,406.674a9.7,9.7,0,0,0,0-9.172.478.478,0,0,0-.841.454,8.672,8.672,0,0,1,0,8.264.477.477,0,1,0,.829.474Zm2.017,1.484a12.159,12.159,0,0,0,0-12.141.478.478,0,1,0-.827.478,11.2,11.2,0,0,1,0,11.184.478.478,0,1,0,.827.478Zm-3.872-3.608"
          fill="#777"
        />
      </g>
    </g>
  </svg>
</template>
